module.exports = "<a href={{link}}> <div ng-transclude></div> {{name}} </a> ";